document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('[data-warranty-registration]');
  if (!section || section.dataset.warrantyInitialized) return;
  section.dataset.warrantyInitialized = 'true';

  const dropdown = section.querySelector('[data-warranty-dropdown]');
  const trigger = section.querySelector('[data-warranty-trigger]');
  const triggerLabel = section.querySelector('[data-warranty-trigger-label]');
  const panel = section.querySelector('[data-warranty-panel]');
  const chevron = section.querySelector('[data-warranty-chevron]');
  const hiddenInput = section.querySelector('[data-warranty-value]');
  const options = section.querySelectorAll('[data-warranty-option]');
  const clearBtn = section.querySelector('[data-warranty-clear]');
  const phoneInput = section.querySelector('[data-warranty-phone]');
  const dropdownError = section.querySelector('[data-warranty-dropdown-error]');
  const PLACEHOLDER = trigger?.dataset.warrantyPlaceholder ?? 'Select Product';

  const closeDropdown = () => {
    panel?.classList.add('hidden');
    chevron?.classList.remove('warranty-registration__dropdown-chevron--open');
    trigger?.setAttribute('aria-expanded', 'false');
  };

  const openDropdown = () => {
    panel?.classList.remove('hidden');
    chevron?.classList.add('warranty-registration__dropdown-chevron--open');
    trigger?.setAttribute('aria-expanded', 'true');
  };

  const selectOption = (option) => {
    const title = option.dataset.warrantyOption;

    if (triggerLabel) triggerLabel.textContent = title;
    if (hiddenInput) hiddenInput.value = title;

    trigger?.setAttribute('data-selected', '');
    dropdownError?.classList.add('hidden');

    for (const opt of options) {
      opt.removeAttribute('data-selected');
    }
    option.setAttribute('data-selected', '');

    closeDropdown();
  };

  if (trigger && panel) {
    trigger.addEventListener('click', () => {
      const isOpen = !panel.classList.contains('hidden');
      if (isOpen) {
        closeDropdown();
      } else {
        openDropdown();
      }
    });
  }

  for (const option of options) {
    option.addEventListener('click', () => selectOption(option));
  }

  document.addEventListener('click', (e) => {
    if (dropdown && document.contains(dropdown) && !dropdown.contains(e.target)) {
      closeDropdown();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDropdown();
  });

  const dateWrapper = section.querySelector('[data-warranty-date-wrapper]');
  const dateInput = section.querySelector('[data-warranty-date]');
  if (dateWrapper && dateInput) {
    dateWrapper.addEventListener('click', () => {
      try {
        dateInput.showPicker();
      } catch {
        dateInput.focus();
      }
    });
  }

  if (phoneInput) {
    phoneInput.addEventListener('input', () => {
      phoneInput.value = phoneInput.value.replace(/\D/g, '').slice(0, 10);
    });
  }

  const form = section.querySelector('[data-warranty-form]');
  const submitBtn = section.querySelector('[data-warranty-submit]');
  const successEl = section.querySelector('[data-warranty-success]');

  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      if (dropdown && !hiddenInput?.value) {
        dropdownError?.classList.remove('hidden');
        trigger?.focus();
        return;
      }

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const googleFormUrl = form.dataset.googleFormUrl;
      if (!googleFormUrl) return;

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending...';
      }

      const firstName = section.querySelector('#warranty-first-name')?.value ?? '';
      const lastName = section.querySelector('#warranty-last-name')?.value ?? '';
      const fullName = `${firstName} ${lastName}`.trim();

      const params = new URLSearchParams({
        'entry.1319117619': fullName,
        'entry.151253499': section.querySelector('#warranty-email')?.value ?? '',
        'entry.2141309764': `+91${phoneInput?.value ?? ''}`,
        'entry.570319757': hiddenInput?.value ?? '',
        'entry.947946262': section.querySelector('#warranty-purchase-date')?.value ?? '',
        'entry.1476053043': section.querySelector('input[name="contact[franchise_type]"]:checked')?.value ?? '',
        'entry.864911103': section.querySelector('#warranty-invoice')?.value ?? '',
      });

      try {
        await fetch(googleFormUrl, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: params,
        });
      } catch {
        // no-cors requests may throw on network failure — still show success
      }

      form.classList.add('hidden');
      successEl?.classList.remove('hidden');

      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Send';
      }
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      form?.reset();

      if (triggerLabel) triggerLabel.textContent = PLACEHOLDER;
      if (hiddenInput) hiddenInput.value = '';
      trigger?.removeAttribute('data-selected');
      dropdownError?.classList.add('hidden');

      for (const opt of options) {
        opt.removeAttribute('data-selected');
      }
    });
  }
});
